import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BecareService } from 'src/app/services/becare.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BecareConfigService {

  private static instance: BecareConfigService = null;
  public url = '';

  config: any = {};

  becarelogo: string;

  constructor(private becare: BecareService) {
    this.url = window.location.protocol + '//' + window.location.host;
    this.becare.authStatus().subscribe(status => {
      if (status === true) {
        this.loadConfig();
      }
    });
    BecareConfigService.instance = this;
  }

  public static getInstance(): BecareConfigService {
    return BecareConfigService.instance;
  }

  private loadConfig() {
    this.becare.call('/becare/ui/config').subscribe(result => {
      this.config = (result as any).config;
      this.becarelogo = this.url + this.config.logo;
    });
  }

  public globalProfileValues(profilename: string, profilekey: string): Observable<string[]> {
    return this.becare.call('/profile/global/' + profilename + '/' + profilekey + '/values');
  }
}
